// pages/Dashboard.jsx
import HomeLayout from "../../components/home/HomeLayout";
import MultiBookOrder from "../../components/home/orderComponents/MultiBookOrder";

export default function Dashboard() {
  return (
    <HomeLayout>
      <MultiBookOrder />
    </HomeLayout>
  );
}
